import { Alert, CollapseProps, Typography } from 'antd'

const { Title, Text } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела</b>,
        children: (
            <>
                <p>
                    Раздел «Подготовка к печати» показывает очередь печати на станках. Здесь
                    отмечается, что для отгрузки подготовлены штамп, формы и бланк.
                </p>
                <ul>
                    <li>
                        Отгрузка попадает в очередь, когда ее задание на печать размещают на станке
                        в разделе <Text strong>«Планирование → Печать»</Text>.
                    </li>
                    <li>
                        Записи отсортированы по полям <Text strong>«Порядок»</Text> и <Text strong>"ID"</Text> по возрастанию,
                        при равном порядке — сначала более новые.
                    </li>
                    <li>Список обновляется автоматически примерно раз в 2 минуты.</li>
                </ul>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Что отображается в таблице</b>,
        children: (
            <>
                <p>Колонки идут слева направо в следующем порядке:</p>
                <ol>
                    <li>
                        <Text strong>Номер в очереди</Text> — номер записи в очереди.
                    </li>
                    <li>
                        <Text strong>Порядок</Text> — позиция записи в очереди станка.
                    </li>
                    <li>
                        <Text strong>Заказчик</Text> — клиент отгрузки.
                    </li>
                    <li>
                        <Text strong>Номер отгрузки</Text>.
                    </li>
                    <li>
                        <Text strong>Тираж</Text> — сумма копий по всем позициям отгрузки.
                    </li>
                    <li>
                        <Text strong>Штамп / тубус</Text> — номер штампа и номер тубуса, в котором
                        он хранится. «нет» — тубус не указан.
                    </li>
                    <li>
                        <Text strong>Формы (комплект)</Text> — количество форм в отгрузке.
                    </li>
                    <li>
                        <Text strong>Бланк</Text> (кнопка с глазом) — просмотр производственного
                        бланка.
                    </li>
                    <li>
                        <Text strong>Станок</Text> — станок, на котором запланирована печать.
                    </li>
                    <li>
                        <Text strong>Штамп</Text>, <Text strong>Формы</Text>,{' '}
                        <Text strong>Бланк</Text> (галочки) — отметки о готовности.
                    </li>
                </ol>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Что нужно делать</b>,
        children: (
            <>
                <ol>
                    <li>Найдите отгрузку в очереди по номеру, заказчику или станку.</li>
                    <li>
                        По колонке <Text strong>«Штамп / тубус»</Text> найдите штамп, подготовьте
                        его и поставьте галочку <Text strong>«Штамп»</Text>.
                    </li>
                    <li>
                        Подготовьте комплект форм (количество — в колонке «Формы (комплект)») и
                        поставьте галочку <Text strong>«Формы»</Text>.
                    </li>
                    <li>
                        Откройте бланк кнопкой с глазом, проверьте и распечатайте его. Затем
                        поставьте галочку <Text strong>«Бланк»</Text>.
                    </li>
                </ol>
                <p>
                    Галочка сохраняется сразу после нажатия. Если ее поставили по ошибке, просто
                    снимите ее.
                </p>
                <Alert
                    showIcon
                    type='info'
                    message='Когда отмечены все три галочки, в разделе «Печать» в колонке «Подготовка» у этой записи появится зеленый значок — печатник видит, что к печати все готово.'
                />
            </>
        ),
    },
    {
        key: '4',
        label: <b>Частые вопросы</b>,
        children: (
            <>
                <Title level={3}>Не вижу отгрузку в очереди</Title>
                <p>
                    Отгрузка появляется только после размещения задания на печать на станке в
                    разделе «Планирование → Печать». Подождите автообновления или обновите
                    страницу.
                </p>

                <Title level={3}>Галочки неактивны</Title>
                <p>У роли «Колорист» галочки доступны только для просмотра.</p>

                <Title level={3}>Появилась ошибка «Не удалось обновить параметр»</Title>
                <p>Отметка не сохранилась. Обновите страницу и поставьте галочку еще раз.</p>
            </>
        ),
    },
]
